import { gql } from "@apollo/client";
export const COMPANY_TRIP_UPDATED_SUBSCRIPTION = gql`
  subscription CompanyTripUpdated($companyId: ID) {
    companyTripUpdated(company_id: $companyId) {
      id
      booking_id
      business_booking_id
      client {
        id
        first_name
        last_name
        email
        country_code
        phone_number
        share_code
        profile_picture
        gender
        enabled
        mobile_verified
        email_verified
        type
        rating
        business_id
        stripe_id
      }
      business_client {
        id
        first_name
        last_name
        email
        country_code
        phone_number
        share_code
        profile_picture
        gender
        enabled
        mobile_verified
        email_verified
        type
        rating
        business_id
        stripe_id
      }
      booker_client {
        id
        first_name
        last_name
        email
        country_code
        phone_number
        share_code
        profile_picture
        gender
        enabled
        mobile_verified
        email_verified
        type
        rating
        business_id
        stripe_id
      }
      guest_client {
        id
        full_name
        email
        country_code
        phone_number
      }
      business {
        id
        company_id
        name
        email
      }
      booker {
        id
        first_name
        last_name
        country_code
        phone_number
        email
        enabled
        profile_picture
        address
        post_code
        country
        city
        dob
        type
        company_name
        company_number
        company_vat
        mobile_verified
        email_verified
        date_created
      }
      company_id
      quote {
        id
        estimated_price
        currency
        estimated_distance
        estimated_time
        schedule_date
      }
      driver {
        id
        first_name
        last_name
        email
        country_code
        phone_number
        share_code
        profile_picture
        gender
        enabled
        already_enabled
        is_online
        mobile_verified
        email_verified
        type
        rating
        account_id
        customer_id
        current_device_id
        license
      }
      vehicle {
        id
        make
        model
        year
        registration_number
        colour
      }
      origin {
        formatted_address
        latitude
        longitude
        poi
        postcode
      }
      destination {
        formatted_address
        latitude
        longitude
        poi
        postcode
      }
      drop_location {
        formatted_address
        latitude
        longitude
        poi
        postcode
      }
      via {
        formatted_address
        latitude
        longitude
        poi
        postcode
      }
      via_index
      service_type
      service {
        name
      }
      bl_service_type
      passengers
      luggages
      notes_to_driver
      notes_to_dispatch
      created_date
      schedule_date
      name_board
      airport_journey
      flight_number
      meet_and_greet
      is_asap
      vehicle_temperature
      radio
      left_seat_temperature
      right_seat_temperature
      status
      estimated_distance
      estimated_time
      final_distance
      final_time
      route_picture
      driver_rating
      driver_safe_rating
      driver_rating_comments
      client_rating
      client_safe_rating
      client_rating_comments
      cancel_reason
      is_hourly
      co2_saved
      options {
        id
        name
        icon
        enabled
        position
      }
      fare {
        payment_method
        payment_intent_id
        pay_type
        currency
        estimated_price
        allowed_free_minutes
        incremented_percentage
        base_fare
        tips
        total_paid
        additional_fares {
          id
          name
          amount
        }
        profile {
          id
          name
          email
          card_token
          type
          enabled
        }
        profile_type
        client_fixed_price
        fixed_price
        client_fixed_price
        driver_price
        company_price
        card_details {
          brand
          last4
        }
        fee_type
        fee_amount
      }
      client_incremented_percentage
      provider {
        name
        trip_id
      }
      provider_company_id
      provider_note_to_driver
      provider_service_type
      private_guest
      timestamps {
        new
        accepted
        started
        arrived
        in_progress
        via1
        via2
        via3
        via4
        via5
        drop_off
        completed
        canceled
        provisional_cancellation
      }
      driver_location {
        latitude
        longitude
        speed
        bearing
      }
      provisional_cancellation
      fee_type
      fee_amount
      eta_to_destination
      distance_to_destination
      notification_message
      is_late
      is_incident
      is_dc
      trip_payment_failed
      provider_company_id
      provider_note_to_driver
      provider_service_type
    }
  }
`;
